/*
 * @Author: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @Date: 2025-10-27 09:45:21
 * @LastEditors: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @LastEditTime: 2025-11-13 20:24:34
 * @FilePath: \mpc-monorepo\features\mpc-common\src\utils\versionMonitor.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { throttle } from 'lodash';

export let htmlHash = sessionStorage.getItem('htmlHash');

// 通过localhost是否是ip或者是localhost来判断是否是开发环境

const isDevelopment = () => {
  const hostName = window.location.hostname;
  // 通过正则判断是否是ip
  const isIp = /^(\d{1,3}\.){3}\d{1,3}$/.test(hostName);
  return hostName === 'localhost' || isIp;
}


// 更新HTML的hash值
function updateHash({
    url,
    method = 'HEAD',
    headerKey = 'content-md5',
    storageKey = 'htmlHash',
    onChange
                 }: {
    url: string,
    method?: string,
    headerKey?: string,
    storageKey?: string,
    onChange?: Function
}) {
  try {
    // 通过fetch获取html的header信息，通过header方法获取hash值
    fetch(url, {
      method: method,
    }).then((res) => {
      let hash = res.headers.get(headerKey);
      const oldHash = sessionStorage.getItem(storageKey);
      // 如果没有hash值，存储hash值，则不做任何操作
      if (!hash) {
        return;
      }

      if (!oldHash) {
        sessionStorage.setItem(storageKey, hash);
      } else if (oldHash !== hash) {
        sessionStorage.setItem(storageKey, hash);
        onChange?.(hash);
      }
    });
  } catch (e) {
    console.error('获取header失败', e);
  }

}

// 节流
const throttleUpdateHash = throttle(updateHash, 10000);

// 每次聚焦和切换tab时，检查html版本是否有更新

export function versionMonitor() {

  if (isDevelopment()) {
    return;
  }

  window.addEventListener('focus', () => {
    throttleUpdateHash({
      url: window.location.href,
      onChange: (hash) => {
        if (htmlHash !== hash) {
          window.location.reload();
        }
      }
    });
  });

  window.addEventListener('visibilitychange', () => {
    throttleUpdateHash({
      url: window.location.href,
      onChange: (hash) => {
        if (htmlHash !== hash) {
          window.location.reload();
        }
      }
    });
  });
}

export function versionMonitorByHash() {


  if (isDevelopment()) {
    return;
  }

  // 路由变更时，检查html版本是否有更新
  window.addEventListener('hashchange', () => {
    throttleUpdateHash({
      url: window.location.href,
      onChange: (hash) => {
        if (htmlHash !== hash) {
          window.location.reload();
        }
      }
    });
  });
}
